module.exports = __webpack_public_path__ + "assets/HKNova-Light.eot";


//////////////////
// WEBPACK FOOTER
// ./fonts/HKNova-Light.eot
// module id = 137
// module chunks = 0